"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUTCOffset = exports.getLocalZone = exports.convertZone = void 0;
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var DateTime_1 = require("./DateTime");
var constants_1 = require("./constants");
/**
 * Convert given ISO datetime string to target time zone.
 *
 * ```typescript
 * convertZone('Asia/Shanghai')('2019-01-01T01:00:00.000Z') // 2019-01-01T09:00:00.000+08:00
 * convertZone('+08:00')('2019-01-01T01:00:00.000Z') // 2019-01-01T09:00:00.000+08:00
 * ```
 * */
var convertZone = function (targetZone) { return function (source) { return (0, DateTime_1.toISO)(typeof targetZone === 'number' || constants_1.UTC_OFFSET_REGEXP.test(targetZone)
    ? (0, moment_timezone_1.default)(source).utcOffset(targetZone).format(constants_1.ISO8601_DATE_FOMART)
    : (0, moment_timezone_1.default)(source).tz(targetZone).format(constants_1.ISO8601_DATE_FOMART)); }; };
exports.convertZone = convertZone;
/**
* ```typescript
* getLocalZone() // 'Asia/Shanghai'
* ```
* */
var getLocalZone = function () { return moment_timezone_1.default.tz.guess(); };
exports.getLocalZone = getLocalZone;
/**
* Get given datetime's UTC offset.
*
* @param date  ISO date
* */
var getUTCOffset = function (date) {
    if (!date) {
        return null;
    }
    var parsedDate = moment_timezone_1.default.parseZone(date, undefined, true);
    return parsedDate.isValid() ? parsedDate.utcOffset() : null;
};
exports.getUTCOffset = getUTCOffset;
